var site = site || {};

site.akstur = {
	asset: {
		exists: function(no) {
			if (no) {
				$.ajax({
					method: 'POST',
					url: '/_/moya/sereq/ajax/checkAsset',
					data: {
						no: no
					}
				}).done(function(response) {
					if (response === '1') {
						$('#registrationAllowed', '#aksturEntryForm').val('yes');
						$('#elm_plate', '#aksturEntryForm')
							.removeClass('failed')
							.addClass('success');
					} else {
						$('#registrationAllowed', '#aksturEntryForm').val('');
						$('#elm_plate', '#aksturEntryForm')
							.removeClass('success')
							.addClass('failed');
					}
				})
			}
		}
	},
	form: {
		cleanRegistrationNumber: function(no) {
			return no.toUpperCase().replace(/[^a-zA-Z0-9]/gi,'');
		},
		cleanKm: function(value) {
			return value.replace(/[^0-9]/gi,'');
		}
	},
	entry: {
		onLoad: function() {
			var no = $('#plate', '#aksturEntryForm').val();
			if (no.length > 2) {
				site.akstur.asset.exists(no);
			}
		},
		onRegistrationNumberBlur: function(event) {
			var $target = $(event.target),
				no = $target.val();

			no = site.akstur.form.cleanRegistrationNumber(no);
			$target.val(no);

			if (no.length > 2) {
				site.akstur.asset.exists(no);
			}
		},
		onKmInput: function(event) {
			var $target = $(event.target),
				value = $target.val();

			value = site.akstur.form.cleanKm(value);
			$target.val(value);
		}
	},
}
